import styled from 'styled-components'

export const DetailDiv = styled.div`
display:flex;
justify-content:center;
min-height: 201px;


h5{
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #18191F;
}

p{
    line-height: 26px;
    color: #18191F;
}

.roundhouse{
    display:flex;
    flex-direction:row;
    
}
.round{
    border-radius:50%;
    width: 15px;
    background: #1DCDFE;
    height: 15px;
}


`